import { useDeleteGroup as baseUseDeleteGroup } from '@vlabs/api/artemy/client';
import type { Error } from '@vlabs/api/artemy/model';
import { toast } from 'react-toastify';

import { useDeleteSourceGroupTranslation } from '../i18n';
import type { DeleteSourceGroupProps } from '../types';

interface ApiErrorWithResponse {
  response?: { data?: Partial<Error> };
}

export function useDeleteSourceGroup({
  groupId,
  onDeleted = undefined,
}: DeleteSourceGroupProps): {
    onDelete: VoidFunction;
    isPending: boolean;
  } {
  const { t } = useDeleteSourceGroupTranslation();
  const deleteGroup = baseUseDeleteGroup({
    mutation: {
      onSuccess: () => {
        toast.success(t('on_success'));
        onDeleted?.();
      },
      onError: (error) => {
        const desc = (error as ApiErrorWithResponse)?.response?.data?.desc;
        toast.error(desc ?? t('on_error'));
      },
    },
  });

  return {
    onDelete: () => deleteGroup.mutate({ groupId }),
    isPending: deleteGroup.isPending,
  };
}
